import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import core, { API } from '@gin-betting/core';

import ui from 'modules/ui';
import { useCountryInfo } from '../hooks';

const {
    utils: { setSearchString, getAppliedFilters },
} = core;

const {
    actions: { setActiveMobileCountryKey },
} = ui;

interface Input {
    countryCode: string;
    tournaments: API.CategorizerItem[];
}

interface Output {
    totalCount: number;
    handleClickCountryRegion: VoidFn;
}

const useCountryRegionItem = ({ countryCode, tournaments }: Input): Output => {
    const dispatch = useDispatch();

    const { tournamentIds, totalCount } = useCountryInfo({ tournaments });

    const handleClickCountryRegion = useCallback(() => {
        dispatch(setActiveMobileCountryKey(countryCode));

        const firstTournamentId = tournamentIds[0];

        setSearchString({
            ...getAppliedFilters(),
            tournamentId: undefined,
            tournamentIds: firstTournamentId ? [firstTournamentId] : undefined,
        });
    }, [dispatch, countryCode, tournamentIds]);

    return {
        totalCount,
        handleClickCountryRegion,
    };
};

export default useCountryRegionItem;
